import request from './request';

/**
 * @param query
 * @returns {Promise<any>}
 */
function sendQuery(query) {
    const options = {
        endpoint: `/coverage/inquiry?inquiry=${ query }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    sendQuery
};